import {
  apiClient,
  getHash,
  deepCopy,
  __cloneDeep,
  __last,
  getImage,
  pickFields,
  __sortBy,
} from '../../utils';
import { uploadMedias, handleError } from '../';
import { UPLOAD_MEDIA_FOREIGN_TYPES } from '../../config';
import { composeSlide } from './composeSlide';

/**
 * سرویس ادیت اسلایدر برای سورت و حذف اسلایدر ها استفاده میشود
 * @param siteId - آی دی سایت شخصی
 * @param sliderId - آی دی اسلایدر
 * @param slides - اسلاید هایی ک میخاییم ادیت کنیم
 * @param sliderItems - اینهم فیلد اسلاید هائه اما وقتی ازین استفاده میکنیم که اسلاید هامون آماده س و نیازی نیست از حالت کانستاکتور فانکشنیِ داخلِ استیت به حالتی که ای پی آی میخاد تبدیلش کنیم.
 * @param status - استتوس جدید اسلایدر٬  ( فعال : 1 ) و (غیرفعال : 0 ) میباشد
 * @param title - تایتل اسلایدر٬ این برای تمییز دادنِ اسلایدر ها از هم دیگه س و جایی استفاده نمیشه.
 */
export const editSlider = async ({
  siteId,
  sliderId,
  slides = [],
  sliderItems = null,
  status,
  title,
}) => {
  try {
    await (slides || []).reduce(
      (acc, { file, id, caption, link, modified }, ci) =>
        acc.then(
          (_) =>
            new Promise((resolve, reject) =>
              !modified
                ? resolve()
                : composeSlide({
                    slideId: id,
                    sliderId,
                    siteId,
                    file,
                    caption,
                    url: link,
                  })
                    .then(({ result }) => {
                      const _slides = result?.slider?.items || result?.items;
                      const { _id, url, cover } = _slides[ci];
                      if (_id) slides[ci].id = _id;
                      if (cover?.hash)
                        slides[ci].file = getImage(cover.hash, 'original');
                      if (cover?.url) slides[ci].url = cover.url;
                      if (cover?.caption) slides[ci].caption = cover.caption;
                      resolve(_slides[ci]);
                    })
                    .catch((err) => reject(err))
            )
        ),
      Promise.resolve()
    );
    const newSlides = __sortBy(slides, 'order').map(
      ({ id, file, caption, link }) => ({
        cover: { hash: getHash(file), type: 0, caption, mimeType: 'image/png' },
        url: link,
      })
    );
    const payload = {
      data: {
        site: siteId,
        slider: sliderId,
        ...(title ? { title } : {}),
        ...(status !== undefined ? { status } : {}),
        ...(newSlides.length ? { items: newSlides } : {}),
        ...(Array.isArray(sliderItems) ? { items: sliderItems } : {}),
      },
    };
    const { result } = await apiClient.post('/merchant/slider/edit', payload);
    return result;
  } catch (e) {
    handleError(e);
    throw e;
  }
};
